import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import Header from "../../components/Header";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const DiscourseBrandingDetails = ({
  onHandleNftCustomizationInputChange,
  onHandleCustomLogo,
  nftCustomizationDetails,
}) => {
  return (
    <Box>
      <Header title="Branding Details" subtitle="Fill the required field" />
      <Accordion expanded={true} style={{ width: "900px" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="page-logo-content"
          id="page-logo-header"
        >
          <Typography style={{ color: "#006A50" }}>
            <b>Upload your background for the page :</b>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid item md={6} xs={6} sm={6}>
            <Box
              component="img"
              sx={{
                width: 400,
                maxHeight: { xs: 233, md: 167 },
                maxWidth: { xs: 350, md: 250 },
              }}
              src={nftCustomizationDetails.customBackground}
            />
            <br />
            <Button
              className="custom-color-button"
              component="label"
              variant="contained"
              startIcon={<CloudUploadIcon />}
            >
              Upload file
              <VisuallyHiddenInput
                name="customBackground"
                id="customBackground"
                onChange={onHandleCustomLogo}
                accept="image/*"
                type="file"
              />
            </Button>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Accordion style={{ width: "900px" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="connect-wallet-button-content"
          id="connect-wallet-button-header"
        >
          <Typography style={{ color: "#006A50" }}>
            <b>Page Text Customisation :</b>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color: "#000080" }}>
                <b>Page Title</b>
              </p>
              <TextField
                sx={{ boxShadow: 2 }}
                fullWidth
                required
                name="pageTitle"
                label={"Page title"}
                variant="outlined"
                type="text"
                id="pageTitle"
                value={nftCustomizationDetails.pageTitle}
                onChange={onHandleNftCustomizationInputChange}
              />
            </Grid>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color: "#000080" }}>
                <b>Title Text Color</b>
              </p>
              <TextField
                name="pageTitleTextColor"
                variant="outlined"
                type="color"
                size="small"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.pageTitleTextColor}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color: "#000080" }}>
                <b>Page description</b>
              </p>
              <TextField
                sx={{ boxShadow: 2 }}
                fullWidth
                required
                name="pageDescription"
                label={"Page description"}
                variant="outlined"
                type="text"
                id="pageTitle"
                value={nftCustomizationDetails.pageDescription}
                onChange={onHandleNftCustomizationInputChange}
              />
            </Grid>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color: "#000080" }}>
                <b>Description Text Color</b>
              </p>
              <TextField
                name="pageDescriptionTextColor"
                variant="outlined"
                type="color"
                size="small"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.pageDescriptionTextColor}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion style={{ width: "900px" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="buy-nfts-button-content"
          id="buy-nfts-button-header"
        >
          <Typography style={{ color: "#006A50" }}>
            <b>Connect Wallet Button Customisation :</b>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{ display: "flex" }}
            alignItems="center"
            justifyContent="center"
          >
            <Button
              style={{
                backgroundColor:
                  nftCustomizationDetails.connectWalletButtonColor,
                color: nftCustomizationDetails.connectWalletButtonTextColor,
              }}
            >
              {nftCustomizationDetails.connectWalletButtonText}
            </Button>
          </Box>
          <Grid container spacing={3}>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color: "#000080" }}>
                <b>Button Color</b>
              </p>
              <TextField
                name="connectWalletButtonColor"
                variant="outlined"
                size="small"
                type="color"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.connectWalletButtonColor}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color: "#000080" }}>
                <b>Button Text Color</b>
              </p>
              <TextField
                name="connectWalletButtonTextColor"
                variant="outlined"
                type="color"
                size="small"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.connectWalletButtonTextColor}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
            <Grid item md={6} xs={6} sm={6}>
              <p style={{ color: "#000080", marginTop: "0" }}>
                <b>Button Text</b>
              </p>
              <TextField
                name="connectWalletButtonText"
                variant="outlined"
                type="text"
                fullWidth
                sx={{ boxShadow: 2 }}
                value={nftCustomizationDetails.connectWalletButtonText}
                onChange={onHandleNftCustomizationInputChange}
                required
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default DiscourseBrandingDetails;
